<section>
	<div class="dz-text-16-bold padding-top-layout-4" dcrHTMLKey="SELECT_PLATFORM_TITLE">Select a Platform</div>
	<div class="dz-text-14 padding-top-layout-1" dcrHTMLKey="SELECT_PLATFORM_MAIN">Access a library of your external portfolios by selecting a platform from the list below.</div>
	<div class="dz-flex padding-top-layout-4">
		<dz-card
			*ngFor="let partner of partnerList"
			(selectionChange)="togglePartnerSelection(partner.id)"
			class="padding-right-object-4 dz-justify-content-left"
			[cardOptions]="{ isSelectable: true, size: [225, 50] }"
			[isSelected]="partner.isSelected"
			custom-tracking
			[track-event]="'selected-partner:' + partner.id"
		>
			<dz-icon dzCardSelected type="check"></dz-icon>
			<dz-card-title align="left" class="dz-text-16-bold dz-flex dz-align-items-center">
				<div class="logo-text" *ngIf="!logoLoaded?.[partner.id]">{{partnerPlatformControlsList?.[partner.id]?.displayName}}</div>
				<img
					ada-decorative
					*ngIf="partnerPlatformControlsList?.[partner.id]?.logo"
					[remote-src]="partnerPlatformControlsList?.[partner.id]?.logo"
					(load)="logoLoaded[partner.id] = true"
					[hidden]="!!!logoLoaded?.[partner.id]"
				/>
			</dz-card-title>
			<div dzCardContent align="left"></div>
		</dz-card>
		<ng-container *ngIf="isPartnerListLoading">
			<dz-card
				*ngFor="let partner of partnerPlatformControlsList | keyvalue"
				class="padding-right-object-4 dz-justify-content-left"
				[cardOptions]="{ isSelectable: true, size: [225, 50] }"
			>
				<dz-card-title align="left">
					<ngx-skeleton-loader [theme]="{ width: '130px', 'border-radius': '0', height: '20px', 'margin-top': '15px' }"></ngx-skeleton-loader>
				</dz-card-title>
			</dz-card>
		</ng-container>
	</div>
	<div class="dz-text-14 padding-bottom-layout-2 envestnet-note dz-underline" dcrHTMLKey="SELECT_PLATFORM_ENVESTNET">
		Looking for Envestnet? <a href="https://www.blackrock.com/us/financial-professionals/advisor-center-envestnet-resources">Learn how to access</a> BlackRock tools through the
		Envestnet platform.
	</div>
</section>
